import CryptoJS from 'crypto-js';

export const encrypt = (text, key) => {
  if (!text) return '';
  return CryptoJS.AES.encrypt(text, key).toString();
};

export const decrypt = (text, key) => {
  if (!text) return '';
  try {
    const bytes = CryptoJS.AES.decrypt(text, key);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    // If decryption failed (wrong key), toString returns empty string or malformed data
    // Return empty string to indicate decryption failure
    return decrypted || '';
  } catch (error) {
    // Handle malformed UTF-8 data or other decryption errors gracefully
    return '';
  }
};

export const isEncrypted = (text) => {
  try {
    if (!text) return false;
    // Encrypted data typically starts with 'U2F' for AES
    return text.startsWith('U2F');
  } catch (error) {
    return false;
  }
};

export const decryptIfNeeded = (text, key) => {
  if (!text) return '';
  return isEncrypted(text) ? decrypt(text, key) : text;
};

export const isSubtaskEncrypted = (subtask) => {
  if (!subtask || !subtask.text) return false;
  return isEncrypted(subtask.text);
};

export const encryptSubtask = (subtask, key) => ({
  completed: subtask.completed,
  text: encrypt(subtask.text, key),
  // link is stored as plain text (not encrypted)
  link: subtask.link || ''
});

export const decryptSubtask = (subtask, key) => ({
  completed: subtask.completed,
  text: decryptIfNeeded(subtask.text, key),
  // link is stored as plain text (not encrypted)
  link: subtask.link || ''
});

export const encryptSubtasks = (subtasks, key) => {
  if (!subtasks || !Array.isArray(subtasks)) return [];
  return subtasks.map(subtask => encryptSubtask(subtask, key));
};

export const decryptSubtasks = (subtasks, key) => {
  if (!subtasks || !Array.isArray(subtasks)) return [];
  return subtasks.map(subtask => decryptSubtask(subtask, key));
};

export const areSubtasksEncrypted = (subtasks) => {
  if (!subtasks || !Array.isArray(subtasks)) return false;
  return subtasks.every(subtask => isEncrypted(subtask));
};

export const encryptIdea = (data, key) => ({
  ...data,
  idea: encrypt(data.idea, key),
  description: encrypt(data.description || '', key),
  status: encrypt(data.status || '', key),
  subtasks: encryptSubtasks(data.subtasks, key),
  // lessonsLearned is stored as plain text (not encrypted)
  lessonsLearned: data.lessonsLearned || '',
  // resources is stored as plain text (not encrypted)
  resources: data.resources || [],
  // color is stored as plain text (not encrypted) - hex color code
  color: data.color || null
});

export const decryptIdea = (data, key) => ({
  ...data,
  idea: decryptIfNeeded(data.idea, key),
  description: decryptIfNeeded(data.description, key),
  status: decryptIfNeeded(data.status, key),
  subtasks: decryptSubtasks(data.subtasks, key),
  // lessonsLearned is stored as plain text (not encrypted)
  lessonsLearned: data.lessonsLearned || '',
  // resources is stored as plain text (not encrypted)
  resources: data.resources || [],
  // color is stored as plain text (not encrypted) - hex color code
  color: data.color || null
});

export const encryptTag = (data, key) => ({
  ...data,
  name: encrypt(data.name, key)
});

export const decryptTag = (data, key) => ({
  ...data,
  name: decrypt(data.name, key)
});